'use strict';

const baseSearch = require('brand_core/components/search');

/**
 * Search event key handler
 */
function suggestionKeyHandler() {
    $('input.js-search-field').each(function () {
        const tabKey = 9;
        let timeout = null;
        $(this).on('keyup', function (e) {
            if (e.which !== tabKey) {
                clearTimeout(timeout);
                // Make a new timeout set to go off in 800ms
                timeout = setTimeout(() => baseSearch.getSuggestions(e.target), 500);
            }
        });
    });
}

/**
 * Tear down search and close popover
 * @param {jQuery} $target jquery reference to target element
 */
function tearDownSearch($target) {
    if ($target && $target.hasClass('js-action-search-close')) {
        $('.js-search-suggestions').empty();
        $('.js-search-field').val('');
    }
    $.enableScroll();
}

/**
 * New brand new search UI functions
 */

/**
 * Clear text in search box and show default quick link
 */
function clearSearchBoxandSuggestions() {
    $('.js-search-field').val('').trigger('input');
    $('.js-search-suggestions').empty();
    $('.js-search-quicklinks').removeClass('d-none');
}

/**
 * close function for desktop and mobile popover
 */
function closeSearchPopover() {
    $('.js-site-header').removeClass('search-suggestion-open');
    $('.js-header-search').addClass('d-none');
    $.enableScroll();
}

/**
 * New brand design search events
 */
function searchBrandNewEvents() {
    let searchCloseTimeout;

    // Function for open search suggestion form
    $('.js-header-search-icon').on('click', function (e) {
        e.preventDefault();
        $('.js-header-search').removeClass('d-none');
        $('.js-search-field').trigger('focus');
        $('.js-site-header').addClass('search-suggestion-open');
        $.disableScroll();
    });

    // Function for close timeout when mouseenter from suggestion
    $('.js-header-search, .suggestions__item').on('mouseenter', function () {
        clearTimeout(searchCloseTimeout);
    });

    // Function for close search suggestion form when mouse leave from suggestion
    $('.js-header-search, .suggestions__item').on('mouseleave', function () {
        searchCloseTimeout = setTimeout(() => {
            closeSearchPopover();
        }, 300);
    });

    // close mobile search popover
    $('.js-action-search-close').on('click', function (e) {
        e.preventDefault();
        closeSearchPopover();
    });

    // Clear text in search box
    $('.js-action-search-clear').on('click', function (e) {
        e.preventDefault();
        clearSearchBoxandSuggestions();
    });

    // trigger text box for rest button
    $('.js-search-field').on('input', function () {
        if ($(this).val().length > 0) {
            $('.js-action-search-clear').removeClass('d-none').addClass('d-block');
        } else {
            $('.js-action-search-clear').removeClass('d-block').addClass('d-none');
        }
    });
}

/**
 * Initialize functions
 */
function init() {
    baseSearch.keyboardNav.init();
    baseSearch.searchEvents();
    searchBrandNewEvents();
    closeSearchPopover();
    clearSearchBoxandSuggestions();
}

module.exports = function () {
    // Override for columbia
    baseSearch.suggestionKeyHandler = suggestionKeyHandler;
    baseSearch.tearDownSearch = tearDownSearch;
    init();
};
